import { httpClient } from '../httpClient';

/**
 * Classification Analytics API -- dashboard, stats, reports, intelligence.
 * Extracted from classification.js (T117).
 */
export const classificationAnalyticsApi = {
  // ── Dashboard & Stats ──────────────────────────────────────────────────
  getStats: () =>
    httpClient.get('/classification/stats'),

  getDashboard: (timeRange) =>
    httpClient.get(`/classification/dashboard?time_range=${timeRange}`),

  // ── Intelligence ───────────────────────────────────────────────────────
  getArticleMappings: (lang) =>
    httpClient.get(`/classification/intelligence/article-mapping?lang=${lang}`),

  getClassificationIntelligence: (classificationId, lang) =>
    httpClient.get(`/classification/intelligence/classification/${classificationId}?lang=${lang}`),

  getSourceSummary: (sourceId, lang) =>
    httpClient.get(`/classification/intelligence/source-summary/${sourceId}?lang=${lang}`),

  getRetentionAlerts: () =>
    httpClient.get('/classification/intelligence/retention-alerts'),

  getUnscannedSuggestions: () =>
    httpClient.get('/classification/intelligence/unscanned-suggestions'),

  getBreachImpact: (sourceId) =>
    httpClient.get(`/classification/intelligence/breach-impact?source_id=${sourceId}`),

  getComplianceMap: (lang) =>
    httpClient.get(`/classification/intelligence/compliance-map?lang=${lang}`),

  getReadinessScore: (queryString) =>
    httpClient.get(`/classification/readiness${queryString ? `?${queryString}` : ''}`),

  refreshReadiness: () =>
    httpClient.post('/classification/readiness/snapshot'),

  // ── Reports ────────────────────────────────────────────────────────────
  getPDPLSummary: () =>
    httpClient.get('/classification/reports/pdpl-summary'),

  getCoverageReport: () =>
    httpClient.get('/classification/reports/coverage'),

  // --- Review Center: Analytics ---
  getReviewKPIs: (queryString) =>
    httpClient.get(`/classification/reviews/analytics/kpis?${queryString}`),

  getReviewVelocity: (queryString) =>
    httpClient.get(`/classification/reviews/analytics/velocity?${queryString}`),

  getReviewOutcomes: (queryString) =>
    httpClient.get(`/classification/reviews/analytics/outcomes?${queryString}`),

  getSLACompliance: (queryString) =>
    httpClient.get(`/classification/reviews/analytics/sla-compliance?${queryString}`),

  getReviewerActivity: (queryString) =>
    httpClient.get(`/classification/reviews/analytics/reviewer-activity?${queryString}`),

  getPatternEffectiveness: () =>
    httpClient.get('/classification/reviews/analytics/patterns'),

  // --- Review Center: Audit Package ---
  getAuditPackageData: (days) =>
    httpClient.get(`/classification/reviews/analytics/audit-package?days=${days}`),

  // T276 (FR-030) — signed, bilingual audit package rendered server-side.
  // Fetched as a blob; the response carries the X-PrivacyGuard-Payload-Hash
  // integrity header used to surface the chain-of-custody hash in the UI.
  getAuditPackagePdf: (days, lang) =>
    httpClient.get('/classification/reviews/analytics/audit-package', {
      params: { days, format: 'pdf', lang },
      responseType: 'blob',
    }),

  getDepartmentScorecards: () =>
    httpClient.get('/classification/reviews/analytics/department-scorecards'),
};
